import React from "react";
import { withSentryTracing } from "supercell-frontend-base/src/tracing/sentry";
import { AppController } from "./controller";

import { SnowplowContextProvider } from "supercell-frontend-base/src/analytics/snowplow";
import {
    ClashOfClansGameParams,
    ClashOfClansGameParamsSchema,
} from "../../validation/game-params";
import {
    GameParamsContextProvider,
    DEFAULT_STATE,
} from "supercell-frontend-base/src/stores/gameParams";

const WithGameParams = (props) => {
    return (
        <SnowplowContextProvider
            config={{
                appId: window.SNOWPLOW_APP_ID,
                collectorUrl: window.SNOWPLOW_COLLECTOR_URL,
            }}
        >
            <GameParamsContextProvider<ClashOfClansGameParams>
                initialState={DEFAULT_STATE}
                gameParamsParser={ClashOfClansGameParamsSchema}
            >
                <AppController {...props} />
            </GameParamsContextProvider>
        </SnowplowContextProvider>
    );
};

export const App = withSentryTracing(WithGameParams);
